<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  contentAttributes: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const isButtonReply = computed(
  () => props.contentAttributes?.fromButton === true
);

const buttonLabel = computed(() => {
  switch (props.contentAttributes?.buttonType) {
    case 'list_reply':
      return t('CONVERSATION.BUTTON_REPLY.LIST_REPLY');
    case 'template_button':
      return t('CONVERSATION.BUTTON_REPLY.TEMPLATE_BUTTON');
    default:
      return t('CONVERSATION.BUTTON_REPLY.BUTTON_REPLY');
  }
});
</script>

<template>
  <div
    v-if="isButtonReply"
    class="inline-flex items-center px-2 py-0.5 rounded-full max-w-full bg-n-alpha-2 text-n-slate-11"
  >
    <span class="text-xs font-medium truncate">{{ buttonLabel }}</span>
  </div>
</template>
